import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "asset-repository h-full min-h-0 overflow-hidden flex flex-col bg-slate-50"
};
const _hoisted_2 = {
  class: "toolbar shrink-0 border-b border-slate-200/80 bg-white"
};
const _hoisted_3 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_4 = {
  class: "main-body flex flex-1 min-h-0 bg-slate-50/30"
};
const _hoisted_5 = {
  class: "center-content flex-1 flex flex-col min-w-0 border-r border-slate-200/60 bg-white"
};
import { ref, reactive, computed, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import PageFilterBar from '@/components/PageFilterBar.vue';
import { getFolderTree, getTagList, getAssetPage, getAssetDetail, getVersionList, deleteAsset, deleteFolder, moveFolder as moveFolderApi, moveAsset as moveAssetApi, restoreVersion as restoreVersionApi } from '@/api/assets';
import AssetFolderTree from './components/AssetFolderTree.vue';
import AssetGrid from './components/AssetGrid.vue';
import AssetDetailPanel from './components/AssetDetailPanel.vue';
import AssetUploadDialog from './components/AssetUploadDialog.vue';
import AssetTextCreateDialog from './components/AssetTextCreateDialog.vue';
import AssetFolderDialog from './components/AssetFolderDialog.vue';
import AssetMoveDialog from './components/AssetMoveDialog.vue';
import AssetFolderAclDialog from './components/AssetFolderAclDialog.vue';
import AssetEditDialog from './components/AssetEditDialog.vue';
import AssetTagsEditDialog from './components/AssetTagsEditDialog.vue';
import AssetTagManageDialog from './components/AssetTagManageDialog.vue';
import AssetTextVersionDialog from './components/AssetTextVersionDialog.vue';

// 查询条件

export default {
  __name: 'AssetRepository',
  setup(__props) {
    const query = reactive({
      keyword: '',
      type: '',
      tagIds: [],
      tagMatchMode: 'ANY',
      sortField: 'createTime',
      sortOrder: 'DESC'
    });
    const tagMatchModeOptions = [{
      label: '任一标签',
      value: 'ANY'
    }, {
      label: '全部标签',
      value: 'ALL'
    }];

    // 分页
    const pagination = reactive({
      current: 1,
      size: 20,
      total: 0
    });

    // 文件夹
    const folderTree = ref([]);
    const folderLoading = ref(false);
    const selectedFolderId = ref(null);
    const selectedFolder = ref(null);

    // 计算当前文件夹是否可管理
    const folderManageable = computed(() => {
      if (!selectedFolder.value) return false;
      return isManageableFolder(selectedFolder.value);
    });

    // 素材列表
    const assetList = ref([]);
    const assetLoading = ref(false);

    // 选中素材
    const selectedAssetId = ref(null);
    const selectedAsset = ref(null);
    const versionList = ref([]);
    const versionLoading = ref(false);

    // 当前选中素材所在文件夹是否可管理
    const currentAssetFolderManageable = ref(false);

    // 标签
    const tagList = ref([]);

    // 对话框状态
    const showUploadDialog = ref(false);
    const showTextCreateDialog = ref(false);
    const showTagManageDialog = ref(false);
    const folderDialog = reactive({
      visible: false,
      mode: 'create',
      folder: null,
      parentId: 0
    });
    const folderMoveDialog = reactive({
      visible: false,
      folderId: null,
      folderName: '',
      lockVersion: null
    });
    const folderAclDialog = reactive({
      visible: false,
      folderId: null,
      folderName: '',
      folder: null
    });
    const assetEditDialog = reactive({
      visible: false,
      asset: null
    });
    const assetMoveDialog = reactive({
      visible: false,
      assetId: null,
      assetName: '',
      lockVersion: null
    });
    const assetTagsDialog = reactive({
      visible: false,
      asset: null
    });
    const newVersionDialog = reactive({
      visible: false,
      assetId: null
    });
    const textVersionDialog = reactive({
      visible: false,
      asset: null
    });

    // ========== 数据加载 ==========

    async function fetchFolderTree() {
      folderLoading.value = true;
      try {
        const data = await getFolderTree();
        folderTree.value = data || [];
      } catch {
        // handled by interceptor
      } finally {
        folderLoading.value = false;
      }
    }
    async function fetchTags() {
      try {
        const data = await getTagList();
        tagList.value = data || [];
      } catch {
        // handled by interceptor
      }
    }
    async function fetchAssetList() {
      assetLoading.value = true;
      try {
        const params = {
          page: pagination.current,
          size: pagination.size,
          keyword: query.keyword || undefined,
          type: query.type || undefined,
          tagIds: query.tagIds?.length ? query.tagIds : undefined,
          tagMatchMode: query.tagIds?.length ? query.tagMatchMode : undefined,
          folderId: selectedFolderId.value,
          includeChildren: true,
          sortField: query.sortField,
          sortOrder: query.sortOrder
        };
        const data = await getAssetPage(params);
        assetList.value = data?.records || data?.list || [];
        pagination.total = data?.total || 0;
      } catch {
        // handled by interceptor
      } finally {
        assetLoading.value = false;
      }
    }
    async function fetchAssetDetail() {
      if (!selectedAssetId.value) return;
      try {
        const data = await getAssetDetail(selectedAssetId.value);
        selectedAsset.value = data?.asset || data;
        // 判断当前素材文件夹权限
        if (selectedAsset.value?.folderId) {
          const folder = findFolderById(folderTree.value, selectedAsset.value.folderId);
          currentAssetFolderManageable.value = isManageableFolder(folder);
        } else {
          currentAssetFolderManageable.value = false;
        }
        await fetchVersionList();
      } catch {
        selectedAsset.value = null;
      }
    }
    function findFolderById(tree, id) {
      for (const node of tree) {
        if (node.id === id) return node;
        if (node.children?.length) {
          const found = findFolderById(node.children, id);
          if (found) return found;
        }
      }
      return null;
    }
    function isManageableFolder(folder) {
      return folder?.permissionLevel === 'MANAGE';
    }
    async function fetchVersionList() {
      if (!selectedAssetId.value) return;
      versionLoading.value = true;
      try {
        const data = await getVersionList(selectedAssetId.value);
        versionList.value = data || [];
      } catch {
        // handled by interceptor
      } finally {
        versionLoading.value = false;
      }
    }

    // ========== 事件处理 ==========

    function handleSearch() {
      pagination.current = 1;
      fetchAssetList();
    }
    function handleFolderSelect(folder) {
      selectedFolderId.value = folder?.id || null;
      selectedFolder.value = folder;
      pagination.current = 1;
      fetchAssetList();
    }
    function handleAssetSelect(asset) {
      selectedAssetId.value = asset?.id || null;
      if (asset) {
        fetchAssetDetail();
      } else {
        selectedAsset.value = null;
        versionList.value = [];
      }
    }
    function handleDetailClose() {
      selectedAssetId.value = null;
      selectedAsset.value = null;
      versionList.value = [];
    }
    function handlePageChange(page) {
      pagination.current = page;
      fetchAssetList();
    }
    function handleSizeChange(size) {
      pagination.size = size;
      pagination.current = 1;
      fetchAssetList();
    }
    function handleSortChange({
      field,
      order
    }) {
      const nextField = field || 'createTime';
      if (query.sortField === nextField) {
        query.sortOrder = order || (query.sortOrder === 'ASC' ? 'DESC' : 'ASC');
      } else {
        query.sortField = nextField;
        query.sortOrder = order || 'DESC';
      }
      pagination.current = 1;
      fetchAssetList();
    }

    // ========== 文件夹操作 ==========

    function showFolderCreateDialog(parentFolder) {
      folderDialog.mode = 'create';
      folderDialog.folder = null;
      folderDialog.parentId = parentFolder?.id || 0;
      folderDialog.visible = true;
    }
    function handleFolderEdit(folder) {
      folderDialog.mode = 'edit';
      folderDialog.folder = folder;
      folderDialog.parentId = 0;
      folderDialog.visible = true;
    }
    function handleFolderMove(folder) {
      folderMoveDialog.folderId = folder.id;
      folderMoveDialog.folderName = folder.name;
      folderMoveDialog.lockVersion = folder.lockVersion;
      folderMoveDialog.visible = true;
    }
    async function handleFolderMoveConfirm(targetParentId) {
      try {
        await moveFolderApi(folderMoveDialog.folderId, {
          targetParentId,
          lockVersion: folderMoveDialog.lockVersion
        });
        ElMessage.success('文件夹移动成功');
        folderMoveDialog.visible = false;
        await fetchFolderTree();
      } catch {
        // handled by interceptor
      }
    }
    function handleFolderAcl(folder) {
      folderAclDialog.folderId = folder.id;
      folderAclDialog.folderName = folder.name;
      folderAclDialog.folder = folder;
      folderAclDialog.visible = true;
    }
    async function handleFolderDelete(folder) {
      try {
        await ElMessageBox.confirm(`确定要删除文件夹「${folder.name}」吗？文件夹必须为空才能删除。`, '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await deleteFolder(folder.id);
        ElMessage.success('文件夹已删除');
        if (selectedFolderId.value === folder.id) {
          selectedFolderId.value = null;
          selectedFolder.value = null;
          selectedAssetId.value = null;
          selectedAsset.value = null;
          versionList.value = [];
        }
        await fetchFolderTree();
        await fetchAssetList();
      } catch {
        // cancelled or handled by interceptor
      }
    }

    // ========== 素材操作 ==========

    function handleAssetEdit(asset) {
      assetEditDialog.asset = asset;
      assetEditDialog.visible = true;
    }
    async function handleAssetDelete(asset) {
      try {
        await ElMessageBox.confirm(`确定要删除素材「${asset.name}」吗？删除后素材将不再在列表中展示。`, '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await deleteAsset(asset.id);
        ElMessage.success('素材已删除');
        handleDetailClose();
        await fetchAssetList();
      } catch {
        // 取消或错误
      }
    }
    function handleAssetMove(asset) {
      assetMoveDialog.assetId = asset.id;
      assetMoveDialog.assetName = asset.name;
      assetMoveDialog.lockVersion = asset.lockVersion;
      assetMoveDialog.visible = true;
    }
    async function handleAssetMoveConfirm(targetFolderId) {
      try {
        await moveAssetApi(assetMoveDialog.assetId, {
          targetFolderId,
          lockVersion: assetMoveDialog.lockVersion
        });
        ElMessage.success('素材移动成功');
        assetMoveDialog.visible = false;
        handleDetailClose();
        await fetchAssetList();
      } catch {
        // handled by interceptor
      }
    }
    function handleAssetTagsEdit(asset) {
      assetTagsDialog.asset = asset;
      assetTagsDialog.visible = true;
    }
    function handleNewVersion(asset) {
      if (asset.type === 'TEXT') {
        textVersionDialog.asset = asset;
        textVersionDialog.visible = true;
        return;
      }
      newVersionDialog.assetId = asset.id;
      newVersionDialog.visible = true;
    }
    async function handleRestoreVersion({
      assetId,
      versionId
    }) {
      try {
        await ElMessageBox.confirm('恢复历史版本将创建一个新版本，复制历史版本内容并设为当前版本。确定恢复吗？', '恢复版本', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        });
        await restoreVersionApi(assetId, versionId, {});
        ElMessage.success('版本已恢复');
        await fetchAssetDetail();
      } catch {
        // 取消或错误
      }
    }
    function resetVersionDialogs() {
      newVersionDialog.visible = false;
      newVersionDialog.assetId = null;
      textVersionDialog.visible = false;
      textVersionDialog.asset = null;
    }

    // ========== 成功回调 ==========

    function onUploadSuccess() {
      showUploadDialog.value = false;
      fetchAssetList();
    }
    function onCreateSuccess() {
      showTextCreateDialog.value = false;
      fetchAssetList();
    }
    function onAssetUpdateSuccess() {
      assetEditDialog.visible = false;
      assetTagsDialog.visible = false;
      fetchAssetDetail();
      fetchAssetList();
    }
    function onVersionUploadSuccess() {
      resetVersionDialogs();
      fetchAssetDetail();
      fetchAssetList();
    }

    // ========== 初始化 ==========

    onMounted(() => {
      fetchFolderTree();
      fetchTags();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_segmented = _resolveComponent("el-segmented");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(PageFilterBar, {
        "shell-class": "filter-bar-shell is-embedded",
        "show-refresh": true,
        "refresh-loading": assetLoading.value,
        onRefresh: fetchAssetList
      }, {
        actions: _withCtx(() => [selectedFolder.value && folderManageable.value ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "btn-primary",
          onClick: _cache[4] || (_cache[4] = $event => showUploadDialog.value = true)
        }, " 上传 ")) : _createCommentVNode("", true), selectedFolder.value && folderManageable.value ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "btn-secondary",
          onClick: _cache[5] || (_cache[5] = $event => showTextCreateDialog.value = true)
        }, " 新建文本 ")) : _createCommentVNode("", true), folderManageable.value ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          type: "button",
          class: "btn-secondary",
          onClick: _cache[6] || (_cache[6] = $event => showFolderCreateDialog(selectedFolder.value))
        }, " 新建文件夹 ")) : _createCommentVNode("", true), folderManageable.value ? (_openBlock(), _createElementBlock("button", {
          key: 3,
          type: "button",
          class: "btn-secondary",
          onClick: _cache[7] || (_cache[7] = $event => showTagManageDialog.value = true)
        }, " 标签管理 ")) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => query.keyword = $event),
          type: "text",
          class: "form-search-input form-control-sm w-full",
          placeholder: "搜索素材名称、描述...",
          onKeyup: _withKeys(handleSearch, ["enter"])
        }, null, 544), [[_vModelText, query.keyword]]), _cache[20] || (_cache[20] = _createElementVNode("svg", {
          class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        })], -1))]), _createVNode(_component_el_select, {
          modelValue: query.type,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => query.type = $event),
          placeholder: "请选择类型",
          class: "form-select form-control-sm filter-bar-field",
          onChange: handleSearch
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "全部类型",
            value: ""
          }), _createVNode(_component_el_option, {
            label: "图片",
            value: "IMAGE"
          }), _createVNode(_component_el_option, {
            label: "视频",
            value: "VIDEO"
          }), _createVNode(_component_el_option, {
            label: "文件",
            value: "FILE"
          }), _createVNode(_component_el_option, {
            label: "文本",
            value: "TEXT"
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_select, {
          modelValue: query.tagIds,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => query.tagIds = $event),
          placeholder: "请选择标签",
          class: "form-select form-control-sm filter-bar-field",
          multiple: "",
          clearable: "",
          "collapse-tags": "",
          "collapse-tags-tooltip": "",
          onChange: handleSearch
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagList.value, tag => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: tag.id,
              label: tag.name,
              value: tag.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"]), query.tagIds.length > 1 ? (_openBlock(), _createBlock(_component_el_segmented, {
          key: 0,
          modelValue: query.tagMatchMode,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => query.tagMatchMode = $event),
          options: tagMatchModeOptions,
          size: "small",
          onChange: handleSearch
        }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["refresh-loading"])]), _createElementVNode("div", _hoisted_4, [_createVNode(AssetFolderTree, {
        "tree-data": folderTree.value,
        "selected-id": selectedFolderId.value,
        loading: folderLoading.value,
        class: "shrink-0",
        onSelect: handleFolderSelect,
        onRefresh: fetchFolderTree,
        onCreateRoot: _cache[8] || (_cache[8] = $event => showFolderCreateDialog(null)),
        onEdit: handleFolderEdit,
        onMove: handleFolderMove,
        onAcl: handleFolderAcl,
        onDelete: handleFolderDelete
      }, null, 8, ["tree-data", "selected-id", "loading"]), _createElementVNode("div", _hoisted_5, [_createVNode(AssetGrid, {
        list: assetList.value,
        loading: assetLoading.value,
        "selected-id": selectedAssetId.value,
        total: pagination.total,
        current: pagination.current,
        size: pagination.size,
        "sort-field": query.sortField,
        "sort-order": query.sortOrder,
        onSelect: handleAssetSelect,
        onPageChange: handlePageChange,
        onSizeChange: handleSizeChange,
        onSortChange: handleSortChange
      }, null, 8, ["list", "loading", "selected-id", "total", "current", "size", "sort-field", "sort-order"])]), selectedAsset.value ? (_openBlock(), _createBlock(AssetDetailPanel, {
        key: 0,
        asset: selectedAsset.value,
        versions: versionList.value,
        "versions-loading": versionLoading.value,
        "folder-manageable": currentAssetFolderManageable.value,
        onClose: handleDetailClose,
        onEdit: handleAssetEdit,
        onDelete: handleAssetDelete,
        onMove: handleAssetMove,
        onTags: handleAssetTagsEdit,
        onNewVersion: handleNewVersion,
        onRestoreVersion: handleRestoreVersion,
        onRefresh: fetchAssetDetail
      }, null, 8, ["asset", "versions", "versions-loading", "folder-manageable"])) : _createCommentVNode("", true)]), _createVNode(AssetUploadDialog, {
        visible: showUploadDialog.value,
        "onUpdate:visible": _cache[9] || (_cache[9] = $event => showUploadDialog.value = $event),
        "folder-id": selectedFolderId.value,
        "tag-list": tagList.value,
        onSuccess: onUploadSuccess
      }, null, 8, ["visible", "folder-id", "tag-list"]), _createVNode(AssetTextCreateDialog, {
        visible: showTextCreateDialog.value,
        "onUpdate:visible": _cache[10] || (_cache[10] = $event => showTextCreateDialog.value = $event),
        "folder-id": selectedFolderId.value,
        "tag-list": tagList.value,
        onSuccess: onCreateSuccess
      }, null, 8, ["visible", "folder-id", "tag-list"]), _createVNode(AssetFolderDialog, {
        visible: folderDialog.visible,
        "onUpdate:visible": _cache[11] || (_cache[11] = $event => folderDialog.visible = $event),
        mode: folderDialog.mode,
        folder: folderDialog.folder,
        "parent-id": folderDialog.parentId,
        onSuccess: fetchFolderTree
      }, null, 8, ["visible", "mode", "folder", "parent-id"]), _createVNode(AssetMoveDialog, {
        visible: folderMoveDialog.visible,
        "onUpdate:visible": _cache[12] || (_cache[12] = $event => folderMoveDialog.visible = $event),
        title: "移动文件夹",
        "item-name": folderMoveDialog.folderName,
        "tree-data": folderTree.value,
        "exclude-id": folderMoveDialog.folderId,
        onConfirm: handleFolderMoveConfirm
      }, null, 8, ["visible", "item-name", "tree-data", "exclude-id"]), _createVNode(AssetFolderAclDialog, {
        visible: folderAclDialog.visible,
        "onUpdate:visible": _cache[13] || (_cache[13] = $event => folderAclDialog.visible = $event),
        "folder-id": folderAclDialog.folderId,
        "folder-name": folderAclDialog.folderName,
        folder: folderAclDialog.folder,
        onSuccess: fetchFolderTree
      }, null, 8, ["visible", "folder-id", "folder-name", "folder"]), _createVNode(AssetEditDialog, {
        visible: assetEditDialog.visible,
        "onUpdate:visible": _cache[14] || (_cache[14] = $event => assetEditDialog.visible = $event),
        asset: assetEditDialog.asset,
        onSuccess: onAssetUpdateSuccess
      }, null, 8, ["visible", "asset"]), _createVNode(AssetMoveDialog, {
        visible: assetMoveDialog.visible,
        "onUpdate:visible": _cache[15] || (_cache[15] = $event => assetMoveDialog.visible = $event),
        title: "移动素材",
        "item-name": assetMoveDialog.assetName,
        "tree-data": folderTree.value,
        onConfirm: handleAssetMoveConfirm
      }, null, 8, ["visible", "item-name", "tree-data"]), _createVNode(AssetTagsEditDialog, {
        visible: assetTagsDialog.visible,
        "onUpdate:visible": _cache[16] || (_cache[16] = $event => assetTagsDialog.visible = $event),
        asset: assetTagsDialog.asset,
        "tag-list": tagList.value,
        onSuccess: onAssetUpdateSuccess
      }, null, 8, ["visible", "asset", "tag-list"]), _createVNode(AssetTagManageDialog, {
        visible: showTagManageDialog.value,
        "onUpdate:visible": _cache[17] || (_cache[17] = $event => showTagManageDialog.value = $event),
        onRefresh: fetchTags
      }, null, 8, ["visible"]), _createVNode(AssetUploadDialog, {
        visible: newVersionDialog.visible,
        "onUpdate:visible": _cache[18] || (_cache[18] = $event => newVersionDialog.visible = $event),
        "folder-id": selectedFolderId.value,
        "asset-id": newVersionDialog.assetId,
        "tag-list": tagList.value,
        onSuccess: onVersionUploadSuccess
      }, null, 8, ["visible", "folder-id", "asset-id", "tag-list"]), _createVNode(AssetTextVersionDialog, {
        visible: textVersionDialog.visible,
        "onUpdate:visible": _cache[19] || (_cache[19] = $event => textVersionDialog.visible = $event),
        asset: textVersionDialog.asset,
        onSuccess: onVersionUploadSuccess
      }, null, 8, ["visible", "asset"])]);
    };
  }
};